import { ShieldCheck, Zap, TrendingUp, Headset } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
    { icon: ShieldCheck, label: "Secure Transactions" },
    { icon: Zap, label: "Fast Processing" },
    { icon: TrendingUp, label: "Competitive Rates" },
    { icon: Headset, label: "24/7 Support" },
];

export default function TrustStrip() {
    return (
        <section
            data-testid="trust-strip"
            className="border-y border-[#E4EAF6] bg-white/70"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 md:py-8 grid grid-cols-2 lg:grid-cols-4 gap-5">
                {ITEMS.map(({ icon: Icon, label }, i) => (
                    <Reveal key={label} delay={i * 80}>
                        <div className="flex items-center justify-center gap-3">
                            <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[#EAF2FF] border border-[#D5E4FF]">
                                <Icon className="w-[18px] h-[18px] text-[#1E56FF]" />
                            </span>
                            <span className="text-sm font-semibold text-[#1E2A4A]">
                                {label}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
